// Edge Function URL
export const EDGE_FUNCTION_URL = 'https://jrmuhoeaammwvwgdibdn.supabase.co/functions/v1/smart-action';
